import Image from "next/image";

interface ServiceCardProps {
  imagePath: string;
  isButton: boolean;
  url: string;
  logoWidth: number;
  logoHeight: number;
}

function ServiceCard({ imagePath, isButton, url, logoWidth, logoHeight }: ServiceCardProps) {
  return (
    <a
      href={`${url}`}
      className={`sm:w-[260px] sm:h-[95px] h-[80px] w-[150px] rounded overflow-hidden shadow-lg bg-white transition duration-300 ease-in-out hover:scale-110  
      ${isButton ? "" : "pointer-events-none"}`}
    >
      <div className="flex justify-center align-middle mt-5">
        <Image
          src={require(`/public/images/aiOptOut/${imagePath}`)}
          alt={imagePath}
          className=""
          width={logoWidth}
          height={logoHeight}
          priority
        />
      </div>
    </a>
  );
}

export default ServiceCard;
